import * as yup from 'yup'

export const enterprise = yup.object().shape({
  ruc: yup.string().required('El RUC es obligatorio'),
  nombre: yup.string().required('El nombre es obligatorio'),
  paisId: yup.string().required('El país es obligatorio'),
  telefono1: yup.string().required('El teléfono 1 es obligatorio'),
  departamentoId1: yup.string().required('El departamento 1 es obligatorio'),
  provinciaId1: yup.string().required('La provincia 1 es obligatorio'),
  ubigeo1: yup.string().required('El distrito 1 es obligatorio'),
  direccion1: yup.string().required('La dirección 1 es obligatorio'),
  referencia1: yup.string().required('La referencia 1 es obligatorio'),
})
